export default function configurePolyfills(): void {
  if (!Number.isNaN) {
    // eslint-disable-next-line no-self-compare
    Number.isNaN = v => v !== v;
  }
}
